import type { SchemaColumn } from '@cli-types/core-engine/schema.js'

export function isSortableColumn(column: SchemaColumn): boolean {
  return column.sortable === true
}
